import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'alert-delete',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})
export class AlertComponent {

  @Output() delete = new EventEmitter();
    Delete() {
        this.delete.emit('delete');
    }

}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/alert/alert.component.ts